import React from 'react'
import { Tooltip, Typography, makeStyles, Fade, IconButton } from '@material-ui/core'
import { InfoRounded } from '@material-ui/icons'

const useStyles = makeStyles({
  tooltip: {
    padding: '6px',
    fontSize: '13px',
    maxWidth: '250px',
    lineHeight: '1.5'
  },
  infoIcon: {
    color: '#15b4db',
    fontSize: '18px'
  },
  infoIconBtn: {
    padding: '2px',
    '&:hover': {
      backgroundColor: 'rgba(21, 180, 219, 0.1)'
    }
  }
})

const InfoIconAlongText = ({ infoText }) => {
  const classes = useStyles()
  return (
    <Tooltip
      arrow
      TransitionComponent={Fade}
      title={<Typography className={classes.tooltip}>{infoText}</Typography>}>
      <IconButton className={classes.infoIconBtn}>
        <InfoRounded className={classes.infoIcon} />
      </IconButton>
    </Tooltip>
  )
}

export default InfoIconAlongText
